import React from 'react';
import {useQueryClient} from '@tanstack/react-query';
import {useAuth} from "../../providers/AuthProvider";

import TeamsPanel from '../talent-dashboard/components/TeamsPanel';

import ProfilePanel from './panels/ProfilePanel';
import MembersPanel from './panels/MembersPanel';
import JobsPanel from './panels/JobsPanel';
import ProjectPanel from './panels/ProjectPanel';
import {useClient} from "../../providers/ClientProvider";
import {useAPI} from "../../config/API";


const SupplierDashboard = props => {
    const { auth } = useAuth();
    const clientOrg = useClient();

    const queryClient = useQueryClient();

    const {
        data: dashboardData,
        isFetching,
        isInitialLoading: isLoading,
        error,
        refetch
    } = useAPI('fetchSupplierDashboard', {
        enabled: !!auth && !!auth.clientOrg?.() && auth.canManageClientResourceTalent?.()
    });


    return (
        <div className="talent-portal-dashboard supplier-portal-dashboard px-3 py-4 sm:px-5 sm:py-7 md:py-10">

            <ProfilePanel/>

            <MembersPanel />

            <ProjectPanel
                isLoading={isLoading}
                opportunities={dashboardData?.opportunities}
                error={error}
                refetch={refetch}
                totalUpdates={dashboardData?.total_new_invited_talent_opps}
                lastViewed={dashboardData?.last_viewed_talent_opps}
            />

            <JobsPanel
                isLoading={isLoading}
                error={error}
                refetch={refetch}
                disabled={!clientOrg.total_supplied_matching_talent_users}
                disabledReason={(
                    <span>
                        In order to pursue jobs, you must have talent resources who are <b>available for hire by role</b>
                    </span>
                )}
                stats={dashboardData}
            />

            <TeamsPanel
                isLoading={isLoading}
                disabled={!clientOrg.total_supplied_team_talent_users}
                disabledReason={(
                    <span>
                        In order to setup teams, you must have talent resources who are <b>available for hire by team</b>
                    </span>
                )}
                error={error}
                refetch={refetch}
                teams={dashboardData?.teams}
                colClass="order-[unset] mb-6 w-full sm:px-3 xl:w-4/12"
            />

        </div>
    );
};

SupplierDashboard.propTypes = {};

export default SupplierDashboard;